import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Link,
  Tooltip,
  Stack,
  TextField,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Breadcrumbs,
  Divider,
  Switch,
  DialogContent,
  DialogContentText,
  IconButton,
  Slide
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../context/MessageContext";
import { useApp } from "../context/AppContext";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { FileUploader } from "react-drag-drop-files";
import FileUploaderComponent from "../components/Assets/FileUploader";
import { useParams } from 'react-router-dom'
import { deleteAssets, downloadZipFromBox, getBoxAssets, changeAssetStatus } from "../apis/apiList/boxAssetsApi";
import { getOrganization } from "../apis/apiList/organizationApi";
import ByteToSize from "../components/common-component/ByteToSize";
import BeatLoader from "react-spinners/BeatLoader";
import theme from "../theme/theme";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InviteModal from "../components/Assets/InviteModal";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const override = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#495967',
        color: theme.palette.common.white,
        fontWeight: 500,
        textTransform: 'uppercase'

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const CustomPaginationItem = styled(PaginationItem)(({ theme, selected }) => ({
    backgroundColor: selected ? theme.palette.primary.main : "#495967", // Red for active, dark blue for others
    color: "#fff",
    borderRadius: "0px", // Square but slightly rounded edges
    fontWeight: selected ? "bold" : "normal",
    margin: "0 4px",
    maxHeight: '26px',
    padding: '0px',
    "&:hover": {
      backgroundColor: selected ? "#d40000" : "#1e2a33",
    },
    "&.Mui-selected":{
        backgroundColor: selected ? theme.palette.primary.main : "#495967", // Red for active, dark blue for others
        color: "#fff",
        padding: '0px'
    }
  }));

const ToggleContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '110px',
  height: '35px',
  borderRadius: '20px',
  cursor: 'pointer',
  overflow: 'hidden',
  userSelect: 'none',
  transition: 'background-color 0.3s ease',
}));

function Assets() {
  const navigate = useNavigate();
  const [organization, setOrganization] = useState();
  const [originalBoxAssetsList, setOriginalBoxAssetsList] = useState();
  const [boxAssetsList, setBoxAssetsList] = useState([]);
  const [paginatedBoxAssetsList, setPaginatedBoxAssetsList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedDeleteProject, setSelectedDeleteProject] = useState({});
  const { showMessage } = useMessage();
  const { userDetails } = useApp();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [openFolderId, setOpenFolderId] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: "All Files", href: "#", fileId: null },
  ]);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletingFileId, setDeletingFileId] = useState(null);
  const [deleteName, setDeleteName] = useState('');
  const [deleteFileType, setDeleteFileType] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleOpenDeleteModal = (fileId, itemName, fileType) => {
    setDeletingFileId(fileId);
    setDeleteName(itemName);
    setDeleteFileType(fileType)
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteFileType('')
    setDeleteName('')
    setDeletingFileId('')
    setOpenDeleteModal(false);
  };

  const handleConfirmDelete = async () => {
    if (!deletingFileId) return;
    setIsDeleting(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulated API call
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
      handleCloseDeleteModal();
    }
  };
  
  const handleBreadcrumbClick = async (index, folderId) => {
    // Slice breadcrumbs up to the clicked index (inclusive)
    const newBreadcrumbs = breadcrumbs.slice(0, index + 1);
    setBreadcrumbs(newBreadcrumbs);
    
    // Fetch content based on the clicked breadcrumb
    const clickedBreadcrumb = breadcrumbs[index];
    
    if (index === 0) {
      
      setOpenFolderId(folderId)
      setBoxAssetsList(originalBoxAssetsList);
      handlePagination(originalBoxAssetsList, 1);
      setPage(1);
    } else {
      setOpenFolderId(folderId)
      
      await fetchBoxAssetsSubfolder(clickedBreadcrumb.fileId);
    }
  };

  const handleFolderClick = async (folderName, folderPath, level, folder) => {
    if (level === 0 && folderName === "All Files") {
      setBreadcrumbs([{ label: "All Files", href: "#", fileId: organization.boxFolderId }]);
      setBoxAssetsList(originalBoxAssetsList);
      handlePagination(originalBoxAssetsList, 1);
      setPage(1);
    } else {
      // Fetch subfolder content
      await fetchBoxAssetsSubfolder(folder.fileId);
      
      if (level < breadcrumbs.length - 1) {
        console.log('in if bredcrumb back')
      } else {
        // Add new breadcrumb when clicking on a folder in the table
        setBreadcrumbs(prev => [
          ...prev,
          { 
            label: folderName, 
            href: "#", 
            fileId: folder.fileId 
          }
        ]);
      }
    }
  };

  const fetchBoxAssetsSubfolder = async (parentId) => {
    if (!parentId) return;
    
    let boxData = {
      boxfolderid: parentId,
      order: 'desc'
    };
    
    setLoading(true)
    try {
      const boxAssetsRes = await getBoxAssets(boxData);
      // console.log('boxAssetsRes subfolder', boxAssetsRes.data);

      if (boxAssetsRes?.data.length > 0) {
        const filteredRows = boxAssetsRes.data;
        setBoxAssetsList(filteredRows);
        handlePagination(filteredRows, 1);
        setPage(1);
        setLoading(false)
      } else {
        setBoxAssetsList([]);
        setPaginatedBoxAssetsList([]);
        setLoading(false)
      }
    } catch (error) {
      console.error("Error fetching subfolder assets:", error);
      // Handle error appropriately
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    async function getOrganizationAndAssets() {
      setLoading(true);
      try {
        let data = {
          id: id
        };
        const org = await getOrganization(data);
        setOrganization(org.data)
        let boxData = {
          boxfolderid: org.data.boxFolderId
        };
        setBreadcrumbs([{ label: "All Files", href: "#", fileId: org.data.boxFolderId }])
        setOpenFolderId(org.data.boxFolderId);
        const boxAssetsRes = await getBoxAssets(boxData);
        
        if (boxAssetsRes?.data.length > 0) {
          const filteredRows = boxAssetsRes?.data;
          setBoxAssetsList(filteredRows);
          handlePagination(filteredRows, page);
        }
        setLoading(false);
        
        setOriginalBoxAssetsList(boxAssetsRes.data);
      } catch (error) {
        setLoading(false);
        console.log('error', error);
      } finally {
        setLoading(false);
      }
    }
    
    if (id) {
      getOrganizationAndAssets();
    }
  }, [id]);

  const handleChange = (event, value) => {
    setPage(value);
    handlePagination(boxAssetsList, value);
  };

  const handlePagination = (boxAssetsList, pageNum) => {
    const startIndex = (pageNum - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const pageList = boxAssetsList.slice(startIndex, endIndex);
    setPaginatedBoxAssetsList(pageList);
  };

  const handleFolderOpen = (folder) => {
    setOpenFolderId(folder.fileId);
    handleFolderClick(folder.fileName, "#", breadcrumbs.length - 1, folder);
  };

  const handleSearchChange = (event) => {
    const str = event.target.value.trim()
    setSearchQuery(str);

    const filteredRows = boxAssetsList.filter((asset) =>
      asset.fileName.toLowerCase().includes(str.toLowerCase())
    );
    setPaginatedBoxAssetsList(filteredRows);
    handlePagination(filteredRows, 1);
    setPage(1);
  }

  const updateAssetStatus = (id, newState) =>{
    setPaginatedBoxAssetsList(prevList => 
      prevList.map(item => 
        item._id === id ? { ...item, status: newState } : item
      )
    );
  }

  const handleToggle = async (asset) => {
    const newState = (asset.status == 'active') ? 'inactive': 'active';

    try{
      let data = {
        assetid: asset._id,
        status: newState 
      }

      const statusChange = await changeAssetStatus(data);
      if(statusChange){
        updateAssetStatus(asset._id, statusChange.data.status)
        showMessage(statusChange.message, 'success')
      }
    } catch (err) {
      console.log('error', err);
      if (err?.response) {
        showMessage(err?.response?.data?.message, 'error');
      } else {
          showMessage(err?.message, 'error');
      }
    }
  };
  
  const handleDownload = async (folder) => {
    try{
      let data = {
        folderid: folder.fileId,
        filetype: folder.fileType,
        filename: folder.fileName, 
      }

      const folderRes = await downloadZipFromBox(data);
      
      if(folderRes){
        // showMessage(folderRes.message, 'success')
        let link = document.createElement("a");
        link.href = folderRes.data.download_url;
        let filename = `$filename.zip`;
        link.setAttribute("download", filename);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        
        // Clean up and remove the link
        link.parentNode.removeChild(link);  
      }
    } catch (err) {
      console.log('error', err);
      if (err?.response) {
        showMessage(err?.response?.data?.message, 'error');
      } else {
          showMessage(err?.message, 'error');
      }
    }
  };

  const deleteAssetFromList = (idToRemove) => {
    setBoxAssetsList(prevList => prevList.filter(item => item.fileId !== idToRemove));
    setPaginatedBoxAssetsList(prevList => prevList.filter(item => item.fileId !== idToRemove));
  };
  
  const deleteAssetFromOriginalList = (idToRemove) => {
    setOriginalBoxAssetsList(prevList => prevList.filter(item => item.fileId !== idToRemove));
  };
  
  const handleDelete = async (folder) => {
    setIsDeleting(true);
    try{
      let data = {
        folderid: deletingFileId,
        filetype: deleteFileType
      }
      
      const folderRes = await deleteAssets(data);

      if(folderRes){
        deleteAssetFromList(deletingFileId);
        deleteAssetFromOriginalList(deletingFileId);
        setIsDeleting(false);
        handleCloseDeleteModal()
        showMessage(folderRes.message, 'success');
      }
    } catch (err) {
      console.log('error', err);
      setIsDeleting(false);
      handleCloseDeleteModal()
      if (err?.response) {
        showMessage(err?.response?.data?.message, 'error');
      } else {
          showMessage(err?.message, 'error');
      }
    }
  };

  const handleUploadedFiles = (folderId, newFiles) => {
    const fileBreadcrumb = breadcrumbs.find(label => label.label === 'All Files');
    const isAllFilesFolder = fileBreadcrumb?.id === folderId;
    
    // Update asset lists
    setPaginatedBoxAssetsList(prevList => [...newFiles, ...prevList]);
    setBoxAssetsList(prevList => [ ...newFiles, ...prevList]);

    if (isAllFilesFolder) {
        setOriginalBoxAssetsList(prevList => [...newFiles, ...prevList]);
    } else {
        let newArrayLength = newFiles.length

        setOriginalBoxAssetsList(prevList =>
          [...prevList.map(item =>{
              return String(item.fileId) === String(folderId)
                    ? { ...item, fileCount: (item.fileCount || 0) + newArrayLength }
                    : item
            })
        ]);
    }
  };
 
  return (
    <>
      {loading ? (
        <Box sx={override}>
          <BeatLoader
            color={theme.palette.primary.main}
            loading={loading}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </Box>
      ) : (
        <Box>
          <Stack
            spacing={2}
            direction="row"
            justifyContent="space-between"
            mb={4}
          >
            <Box>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs.map((crumb, index) =>
                  index === breadcrumbs.length - 1 ? (
                    <Typography key={index} color="text.primary">
                      {crumb.label}
                    </Typography>
                  ) : (
                    <Link
                      key={index}
                      underline="hover"
                      color="inherit"
                      href={crumb.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleBreadcrumbClick(index, crumb.fileId);
                      }}
                    >
                      {crumb.label}
                    </Link>
                  )
                )}
              </Breadcrumbs>
            </Box>
            <Stack direction="row" gap="25px" alignItems={"center"}>
              <Box
                onClick={() => {
                  navigate(
                    `/org/${organization._id}/create/folder/${openFolderId}`
                  );
                }}
              >
                <Link>
                  <img
                    style={{ maxHeight: "28px" }}
                    src={require("../assets/assets-icon/create-folder-icon.png")}
                  />
                </Link>
              </Box>
              <Box>
                <div>
                  <input
                    type="text"
                    className="project-search"
                    placeholder="Search"
                    onChange={handleSearchChange}
                  />
                </div>
              </Box>
            </Stack>
          </Stack>
          <Divider />
          <Box mt={3} mb={3}>
            <Box sx={{ my: 4 }}>
              <FileUploaderComponent
                openFolderId={openFolderId}
                handleUploadedFiles={handleUploadedFiles}
              />
            </Box>
          </Box>
          <Divider />
          <Box mt="10px">
            <TableContainer component={Paper} sx={{ mb: "20px" }}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell align="left">Updated</StyledTableCell>
                    <StyledTableCell align="left">Size</StyledTableCell>
                    {userDetails.role == "admin" && ( <StyledTableCell align="center">Status</StyledTableCell> )}
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                {paginatedBoxAssetsList && paginatedBoxAssetsList.length > 0 ? (
                  <TableBody>
                    {paginatedBoxAssetsList.map((asset, index) => (
                      <StyledTableRow
                        key={index}
                        sx={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          align="left"
                          sx={{
                            cursor: "pointer",
                            width: "20%",
                            minWidth: "150px",
                          }}
                          onClick={() => {
                            asset.fileType === "folder" &&
                              handleFolderOpen(asset);
                          }}
                        >
                          <Stack
                            direction="row"
                            gap={2}
                            sx={{ alignItems: "center" }}
                          >
                            {/* {(asset.fileName &&
                              asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                                "jpg") ||
                            asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                              "jpeg" ||
                            asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                              "png" ? ( */}
                            {(() => {
                              const imageExtensions = [
                                "jpg",
                                "jpeg",
                                "png",
                                "gif",
                                "bmp",
                                "webp",
                              ];
                              const fileExtension = asset.fileName
                                ?.split(".")
                                .pop()
                                .toLowerCase();
                              return imageExtensions.includes(fileExtension);
                            })() ? (
                              <img
                                src={asset.assetData}
                                style={{ width: "70px", height: "50px" }}
                                alt="image-thumbnail"
                              />
                            ) : asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                              "pdf" ? (
                              <img
                                src={require("../assets/assets-icon/pdf.jpg")}
                                style={{ width: "70px", height: "50px" }}
                                alt="pdf-icon"
                              />
                            ) : asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                              "mp3" ? (
                              <img
                                src={require("../assets/assets-icon/mp3.png")}
                                style={{ width: "70px", height: "50px" }}
                                alt="mp3-icon"
                              />
                            ) : asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                                "mov" ||
                              asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                                "MOV" ||
                              asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                                "mp4" ||
                              asset.fileName.split(/\.(?=[^\.]+$)/)[1] ===
                                "MP4" ? (
                              !asset.isFileMovedToAssets ? (
                                <img
                                  src={require("../assets/assets-icon/pending-video-thumbnail.png")}
                                  style={{ height: "50px" }}
                                  alt="pending-video-thumbnail"
                                />
                              ) : (
                                <video
                                  width="90"
                                  height="50"
                                  key={asset.assetdata}
                                >
                                  <source
                                    key={asset.assetdata}
                                    src={asset.assetdata}
                                    type="video/mp4"
                                  />
                                  Sorry, your browser doesn't support embedded
                                  videos.
                                </video>
                              )
                            ) : (
                              <img
                                src={require("../assets/assets-icon/folder.png")}
                                alt="folder-icon"
                              />
                            )}
                            <Box sx={{ width: "80%" }}>{asset.fileName}</Box>
                          </Stack>
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          sx={{ width: "10%", minWidth: "150px" }}
                        >
                          {moment(asset.createdAt).format("MM/DD/YYYY")}
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          sx={{ width: "15%", minWidth: "150px" }}
                        >
                          {asset.fileType == "folder" ? (
                            <>{asset.fileCount} Files</>
                          ) : (
                            <>
                              <ByteToSize byte={asset.assetSize} />
                            </>
                          )}
                        </StyledTableCell>
                        {userDetails.role == "admin" && ( <>
                          <StyledTableCell align="right">
                            {/* {asset.status} */}
                            {/* <FormGroup> */}
                            {/* <FormControlLabel
                                sx={{ justifyContent: "center" }}
                                control={<Android12Switch defaultChecked />}
                                // label="Android 12"
                              /> */}
                            {/* <FormControlLabel
                                control={
                                  <IOSSwitch sx={{ m: 1 }} defaultChecked />
                                }
                                // label="iOS style"
                              /> */}
                            {/* <Stack
                                direction="row"
                                spacing={1}
                                sx={{ alignItems: "center" }}
                              >
                                <Typography>Archived</Typography>
                                  <IOSSwitch sx={{ m: 1 }} defaultChecked />
                                <Typography>Active</Typography>
                              </Stack> */}
                            {/* </FormGroup> */}
                            {asset.fileType == "folder" && (
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <ToggleContainer
                                  onClick={() => {
                                    handleToggle(asset, index);
                                  }}
                                  sx={{
                                    backgroundColor:
                                      asset.status == "active"
                                        ? "#2196F3"
                                        : "#CC0000",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "100%",
                                      height: "100%",
                                      color: "white",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      marginLeft: "15px",
                                      ...(asset.status == "active"
                                        ? { justifyContent: "start" }
                                        : { marginLeft: "15px" }),
                                    }}
                                  >
                                    {asset.status == "active"
                                      ? "Active"
                                      : "Archived"}
                                  </Box>
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      [asset.status == "active"
                                        ? "right"
                                        : "left"]: "10px",
                                      transform: "translateY(-50%)",
                                      width: "25px",
                                      height: "25px",
                                      borderRadius: "50%",
                                      backgroundColor: "white",
                                      transition:
                                        "left 0.3s ease, right 0.3s ease",
                                    }}
                                  />
                                </ToggleContainer>
                              </Box>
                            )}
                          
                          </StyledTableCell>
                        </>)}
                        <StyledTableCell align="center">
                          {/* Action buttons here */}
                          <Stack
                            direction={"row"}
                            gap={1}
                            justifyContent="center"
                          >
                            <Tooltip
                              title="Share Link"
                              arrow
                              onClick={() => setModalOpen(true)}
                            >
                              <img
                                src={require("../assets/assets-icon/share.png")}
                                alt="Share link"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  margin: "1px",
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              title="Download"
                              onClick={() => {
                                handleDownload(asset);
                              }}
                              arrow
                            >
                              <img
                                src={require("../assets/assets-icon/dwn.png")}
                                alt="Download"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  margin: "1px",
                                }}
                              />
                            </Tooltip>
                            {
                              userDetails.role == "admin" && (
                                <Tooltip
                                  title="Delete"
                                  onClick={() => {
                                    handleOpenDeleteModal(
                                      asset.fileId,
                                      asset.fileName,
                                      asset.fileType,
                                    );
                                    // handleDelete(asset);
                                  }}
                                  arrow
                                >
                                  <img
                                    src={require("../assets/assets-icon/delete.png")}
                                    alt="Delete"
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                      margin: "1px",
                                    }}
                                  />
                                </Tooltip>
                              )
                            }
                          </Stack>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                ) : (
                  <StyledTableRow sx={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <StyledTableCell align="left">
                      <Typography variant="h5" padding={1}>
                        {" "}
                        No Data Found
                      </Typography>
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </Table>
            </TableContainer>
            <Pagination
              count={Math.ceil(boxAssetsList.length / rowsPerPage)}
              page={page}
              onChange={handleChange}
              renderItem={(item) => <CustomPaginationItem {...item} />}
              siblingCount={1}
              boundaryCount={1}
              showFirstButton
              showLastButton
            />
          </Box>
        </Box>
      )}
      <div>
        <InviteModal open={modalOpen} onClose={() => setModalOpen(false)} />
      </div>
      <Dialog
        open={openDeleteModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteModal}
        aria-describedby="delete-confirmation-dialog"
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: { xs: "90%", sm: "450px" },
            maxWidth: "500px",
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "error.light",
              color: "error.dark",
              borderRadius: "50%",
              padding: 1,
              mr: 2,
            }}
          >
            <DeleteOutlineIcon />
          </Box>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Confirm Deletion
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCloseDeleteModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 3, pt: 1 }}>
          <DialogContentText id="delete-confirmation-dialog" sx={{ mb: 2 }}>
            Are you sure you want to delete <strong>{deleteName}</strong>? This
            action cannot be undone.
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            variant="outlined"
            onClick={handleCloseDeleteModal}
            sx={{ borderRadius: 2, px: 3 }}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            sx={{ borderRadius: 2, px: 3 }}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Assets;